module.exports = __webpack_public_path__ + "static/media/Detail_Icon_01.d65d831e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_01.png
// module id = 1572
// module chunks = 0